var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#32A840",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4167 23.9198H22.0667C22.7167 23.9198 23.2567 23.3398 23.2567 22.6398C23.2567 21.7698 22.9467 21.5998 22.4367 21.4198L21.4267 21.0698V23.9198H21.4167Z",
    fill: "#32A840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6367 9.89992C15.1167 9.91992 10.6467 14.4099 10.6667 19.9299C10.6867 25.4499 15.1767 29.9199 20.6967 29.8999C26.2167 29.8799 30.6867 25.3899 30.6667 19.8699C30.6467 14.3499 26.1567 9.88992 20.6367 9.89992ZM22.9267 19.9999C23.7067 20.2699 24.7567 20.8499 24.7567 22.6399C24.7567 24.1799 23.5467 25.4199 22.0667 25.4199H21.4167V25.9999C21.4167 26.4099 21.0767 26.7499 20.6667 26.7499C20.2567 26.7499 19.9167 26.4099 19.9167 25.9999V25.4199H19.5567C17.9167 25.4199 16.5867 24.0399 16.5867 22.3399C16.5867 21.9299 16.9267 21.5899 17.3367 21.5899C17.7467 21.5899 18.0867 21.9299 18.0867 22.3399C18.0867 23.2099 18.7467 23.9199 19.5567 23.9199H19.9167V20.5399L18.4067 19.9999C17.6267 19.7299 16.5767 19.1499 16.5767 17.3599C16.5767 15.8199 17.7867 14.5799 19.2667 14.5799H19.9167V13.9999C19.9167 13.5899 20.2567 13.2499 20.6667 13.2499C21.0767 13.2499 21.4167 13.5899 21.4167 13.9999V14.5799H21.7767C23.4167 14.5799 24.7467 15.9599 24.7467 17.6599C24.7467 18.0699 24.4067 18.4099 23.9967 18.4099C23.5867 18.4099 23.2467 18.0699 23.2467 17.6599C23.2467 16.7899 22.5867 16.0799 21.7767 16.0799H21.4167V19.4599L22.9267 19.9999Z",
    fill: "#32A840"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0868 17.3701C18.0868 18.2401 18.3968 18.4101 18.9068 18.5901L19.9168 18.9401V16.0801H19.2668C18.6168 16.0801 18.0868 16.6601 18.0868 17.3701Z",
    fill: "#32A840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.5cef6e7bf731c16011001af15d5f80d0.svg";
export { ForwardRef as ReactComponent };